export const validPhone = new RegExp(/^0[0-9]{9}$/)